"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isBrowser = _interopRequireDefault(require("./_internal/isBrowser"));

var _performanceNow = _interopRequireDefault(require("./_internal/performance-now"));

var vendors = ['webkit', 'moz'];
var root = _isBrowser["default"] ? window : global;
var name = 'AnimationFrame'; // @ts-ignore

var raf = root["request" + name]; // @ts-ignore

var caf = root["cancel" + name];

for (var i = 0; i < vendors.length && !raf; i++) {
  // @ts-ignore
  raf = root[vendors[i] + "Request" + name]; // @ts-ignore

  caf = root[vendors[i] + "Cancel" + name];
}

if (!raf || !caf) {
  var queue = [];
  var tick = 1000 / 60;
  var lastTime = 0;
  var id = 0;

  raf = function raf(callback) {
    if (queue.length === 0) {
      var nowTime = (0, _performanceNow["default"])();
      var next = Math.max(0, tick - (nowTime - lastTime));
      lastTime = nowTime + next;
      setTimeout(function () {
        var copiedQueue = queue.slice();
        queue.length = 0;

        for (var _i = 0; _i < copiedQueue.length; _i++) {
          if (!copiedQueue[_i].cancelled) {
            try {
              copiedQueue[_i].callback(lastTime);
            } catch (err) {
              setTimeout(function () {
                throw err;
              }, 0);
            }
          }
        }
      }, Math.round(next));
    }

    var timerId = id++;
    queue.push({
      timerId: timerId,
      callback: callback,
      cancelled: false
    });
    return timerId;
  };

  caf = function caf(timerId) {
    for (var _i2 = 0; _i2 < queue.length; _i2++) {
      if (queue[_i2].timerId === timerId) {
        queue[_i2].cancelled = true;
      }
    }
  };
}

function exposeRaf(fn) {
  return raf.call(root, fn);
}

exposeRaf.cancel = function (timerId) {
  caf.call(root, timerId);
};

var _default = exposeRaf;
exports["default"] = _default;
module.exports = exports.default;